var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPolicyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.535,
    height: 14,
    viewBox: "0 0 12.535 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "secure-shield-password-protect-safe-svgrepo-com",
    transform: "translate(-2.25 -0.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3061",
    "data-name": "Path 3061",
    d: "M8.517,14.375a1.262,1.262,0,0,1-.662-.181L5.361,12.735A6.078,6.078,0,0,1,2.25,7.5V3.509a1.315,1.315,0,0,1,.859-1.233L8.065.455a1.315,1.315,0,0,1,.9,0l4.956,1.821a1.315,1.315,0,0,1,.859,1.233V7.5a6.078,6.078,0,0,1-3.111,5.24L9.179,14.194A1.262,1.262,0,0,1,8.517,14.375Zm0-12.97a.275.275,0,0,0-.1,0L3.462,3.233a.284.284,0,0,0-.185.275V7.5a5.055,5.055,0,0,0,2.6,4.352l2.495,1.463a.3.3,0,0,0,.288,0l2.495-1.463h0a5.055,5.055,0,0,0,2.6-4.352V3.509a.284.284,0,0,0-.185-.267L8.616,1.421a.275.275,0,0,0-.1-.016Z",
    transform: "translate(0 0)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3062",
    "data-name": "Path 3062",
    d: "M12.993,16.369a.5.5,0,0,1-.311-.111l-1.638-1.381a.481.481,0,1,1,.618-.737l1.285,1.082,2.194-2.417a.481.481,0,1,1,.714.644l-2.486,2.762A.487.487,0,0,1,12.993,16.369Z",
    transform: "translate(-4.896 -7.095)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicyIcon);
export default __webpack_public_path__ + "static/media/PolicyIcon.2e9b41aa005d39f7ee999074cd9798df.svg";
export { ForwardRef as ReactComponent };